export const shortenText = (text, maxLength) => {
  const textLength = text.length
  return (textLength <= maxLength) ? text : text.substring(0, (maxLength + 1)) + '...'
}

export const stateText = item => item.stateOfIncorporation ? item.stateOfIncorporation.trim() : ''
export const countryText = item => item.countryOfIncorporation ? item.stateOfIncorporation ? `, ${item.countryOfIncorporation.trim()}` : item.countryOfIncorporation.trim() : ''
export const yearText = item => item.yearOfIncorporation ? (item.stateOfIncorporation || item.countryOfIncorporation) ? `, ${item.yearOfIncorporation}` : item.yearOfIncorporation : ''
